import type { Car } from 'store/slices/cars/types';
import type { Categories } from 'store/slices/cars/types';

export interface CarProps extends Car {
  handleOpenDrawer: () => void;
}

export type CarTypeProps = {
  content: string;
  image: string;
  type: Categories;
};

export type ServiceProps = {
  description: string;
  name: string;
  price: string;
  image: string;
  translate: (key: string) => string;
};

export enum DrawerSteps {
  CAR_DETAILS = 'CAR_DETAILS',
  RESERVATION_DATES = 'RESERVATION_DATES',
  ACCOUNT_CREATION = 'ACCOUNT_CREATION',
  PAYMENT = 'PAYMENT',
  SUCCESS_PAGE = 'SUCCESS_PAGE',
}

export type DrawerStepLinkedList = {
  previous: DrawerSteps | null;
  next: DrawerSteps | null;
};

export const RentalDrawerSteps: Record<DrawerSteps, DrawerStepLinkedList> = {
  [DrawerSteps.CAR_DETAILS]: {
    previous: null,
    next: DrawerSteps.RESERVATION_DATES,
  },
  [DrawerSteps.RESERVATION_DATES]: {
    previous: DrawerSteps.CAR_DETAILS,
    next: DrawerSteps.ACCOUNT_CREATION,
  },
  [DrawerSteps.ACCOUNT_CREATION]: {
    previous: DrawerSteps.RESERVATION_DATES,
    next: DrawerSteps.PAYMENT,
  },
  [DrawerSteps.PAYMENT]: {
    previous: DrawerSteps.ACCOUNT_CREATION,
    next: DrawerSteps.SUCCESS_PAGE,
  },
  [DrawerSteps.SUCCESS_PAGE]: {
    previous: null,
    next: null,
  },
};
